import Vue from 'vue'
import App from './Shuttle.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import { v4 as uuidv4 } from 'uuid';
/* import { H5P } from 'h5p-standalone';*/
import axios from 'axios'
import Vuex from 'vuex'

import CKEditor from '@ckeditor/ckeditor5-vue';

const crypto = require('crypto');
import {Marshaller} from '@aws/dynamodb-auto-marshaller';

import interact from 'interactjs'



import VueFormGenerator from 'vue-form-generator'


Vue.use(Vuex);
Vue.use(CKEditor);
Vue.use(VueFormGenerator, {
  validators: {
    email: (value, field, model) => {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (!re.test(String(value).toLowerCase())) {
        return ['This is not a valid email.'];
      } else {
        return [];
      }
    }
  }
});



var VueCookie = require('vue-cookie');
// Tell Vue to use the plugin
Vue.use(VueCookie);




Vue.prototype.$axios = axios
window.axios = require('axios');

  axios.interceptors.response.use( (response) => {
    // Return a successful response back to the calling service
    return response;
  }, (error) => {
    // Return any error which is not due to authentication back to the calling service
    //console.log(error);

      return new Promise((resolve, reject) => {
        reject(error);
      });


  });




//probabaly best if mixin in a different file at some point.
Vue.mixin({


  methods: {



    fmtMSS(s){return(s-(s%=60))/60+(9<s?':':':0')+Math.round(s)},

      hmsToSecondsOnly(str) {
    var p = str.split(':'),
        s = 0, m = 1;

    while (p.length > 0) {
        s += m * parseInt(p.pop(), 10);
        m *= 60;
    }

    return s;
},


    updateDrawer:function(val){
        this.$store.commit('drawerState', !this.$store.state.drawer);
        //console.log(!this.$store.state.drawer)
        return this.$store.state.drawer;

    },

    getDrawer:function(val){

        //return this.$store.state.drawer;
    },


    encryptString: function (s) {

        var cipher = crypto.createCipher('aes-256-cbc','shuttle-zoom-integration')
          var crypted = cipher.update(s,'utf8','hex')
          crypted += cipher.final('hex');
          return crypted;
    },

    decryptString(s){
        var decipher = crypto.createDecipher('aes-256-cbc','shuttle-zoom-integration')
        var dec = decipher.update(s,'hex','utf8')
        dec += decipher.final('utf8');
         return dec;
    },

    async postData(path, postData) {
          //retryer += 1;
          var api_uri = this.$store.state.uri.api_base_uri;
          var bearertoken = this.$store.state.hashtokens.id_token;

          if (bearertoken.length == 0) {
            console.warn("getIdToken() returned empty string!");
            console.warn("I.E. No token found in cookies!");
          } else {
          var headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + bearertoken};
           let response = await axios.post(
               api_uri + path,
              postData, { headers: headers }
            )
            .catch((error) => {
              /* check token valid */
              console.error("REQUEST FAILED");
              //console.error(error.message);

            })

            return response.data;
          }
        },


    async getData(path, method, postData,api_uri) {
          //retryer += 1;
          var vm = this;

          var api_uri = arguments[3] === undefined ? this.$store.state.uri.api_base_uri : arguments[3];
          var bearertoken = this.$store.state.hashtokens.id_token;

          if (bearertoken.length == 0) {
            console.warn("getIdToken() returned empty string!");
            console.warn("I.E. No token found in cookies!");
          } else {



          var headers;
          if(method == 'get'){
              headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + bearertoken};

          } else {
              headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + bearertoken};

          }

          //try to stop caching
          let response;
          response =  await axios(
                {

                  method:method,
                  url:api_uri + path,
                  headers: headers,
                  data:postData,
                  params: { }
                }
            )
            .catch((error) => {
              /* check token valid */
              console.error("REQUEST FAILED");
              ////console.log(error.message);

              //this.$router.push({path:'/'});

              // refresh

            })


            return response.data;
          }
        },
       async authorizeCognitoUser(){

           var endpoint = 'auth/token'
           var uri = this.$store.state.uri.api_base_uri + endpoint;
           //var postdata = JSON.parse(this.$cookie.get('hashtokens'))
           var postdata = this.$store.state.hashtokens;
           var data = '';
           try {
             let response = await axios.post(uri, postdata);
             data = response.data;
             ////console.log(response);
           } catch (e) {
             // this.errors.push(e)
            ////console.log('LOGIN ERROR: ' + response.errorType);
            //console.log(e);
          }
          return data;

       },


       dynamoMarshall(data) {



    const marshaller = new Marshaller();
      return marshaller.marshallItem(data);

       },


    dynamoUnMarshall(data) {
      const marshaller = new Marshaller();
      return marshaller.unmarshallItem(data);

    },


    cleanObjectDynamo(obj){

      let cObj = Object.assign({},obj);


    for (let [key, value] of Object.entries(cObj)) {
      if(value == ''){delete cObj[key]}

  }
    return cObj;

    }









}
});




Vue.config.productionTip = false


window.H5PIntegration = {};

new Vue({
  router,
  store,
  vuetify,
  axios,
  render: h => h(App)
}).$mount('#app')
